import { Col } from 'antd';
// eslint-disable-next-line max-len
import { type ConfiguratorApplicationEntrypointContextDataFragment } from '../../../../api/fragments/ConfiguratorApplicationEntrypointContextData';
import { type KycFieldSpecsFragment } from '../../../../api/fragments/KYCFieldSpecs';
import Ocr, { useOcrDetectedHandler } from '../../../../components/ocr';

export type OcrContentProps = {
    endpoint: ConfiguratorApplicationEntrypointContextDataFragment;
    withMyInfo: boolean;
    kycPresets: KycFieldSpecsFragment[];
};

const OcrContent = ({ endpoint, withMyInfo, kycPresets }: OcrContentProps) => {
    const { isOcrEnabled } = endpoint.configuratorApplicationModule;
    const showOcr = !withMyInfo && isOcrEnabled;

    const onOcrDetected = useOcrDetectedHandler(kycPresets);

    if (!showOcr) {
        return null;
    }

    return (
        <Col span={24}>
            <Ocr onDetected={onOcrDetected} />
        </Col>
    );
};

export default OcrContent;
